import React from "react";
import CampaignBuilder from "../../components/campaignBuilder/campaignBuilder";

const LxdcEmail = () => {
  return <CampaignBuilder appName="lxdc" />;
};

export default LxdcEmail;
